// UI strings for each person's own reminders in Asetukset → Ilmoitukset (reminders/plan.settings.tsx;
// engine/src/reminder-plan.ts): the evening one for new words and the short morning one for last
// night's words, each with its own time and an "after ___" anchor. Finnish per docs/FINNISH-STYLE.md.
// The notification text itself is written by the API (api/src/push/plan.ts).
import { defineArea } from '../area';

export const reminderPlanFi = {
  title: 'Omat muistutukset',
  evening: 'Illalla: uudet sanat',
  morning: 'Aamulla: eilisillan sanat',
  time: 'Kello',
  /** Placeholder of the evening time when the shared one applies. */
  sharedTime: (time: string) => `yhteinen aika ${time}`,
  /** Under an empty evening time (iOS shows no placeholder in a time field). */
  sharedInUse: (time: string) => `Käytössä on yhteinen aika ${time}.`,
  /** Clears an own evening time. */
  useShared: 'Käytä yhteistä aikaa',
  after: 'Minkä jälkeen?',
  eveningAfterExample: 'esim. iltapalan jälkeen',
  morningAfterExample: 'esim. aamukahvin jälkeen',
  morningOn: 'Lyhyt aamumuistutus',
  save: 'Tallenna',
  saved: 'Tallennettu.',
  /** The notification as it will read (the anchor first). */
  preview: (text: string) => `Ilmoitus: ${text}`,
  eveningText: 'Illan uudet sanat odottavat.',
  morningText: 'Eilisillan uudet sanat: ensin lyhyt kertaus.',
};

export const reminderPlanEn: typeof reminderPlanFi = {
  title: 'Your own reminders',
  evening: 'Evening: new words',
  morning: "Morning: last night's words",
  time: 'Time',
  sharedTime: (time) => `shared time ${time}`,
  sharedInUse: (time) => `The shared time ${time} applies.`,
  useShared: 'Use the shared time',
  after: 'After what?',
  eveningAfterExample: 'e.g. after supper',
  morningAfterExample: 'e.g. after morning coffee',
  morningOn: 'Short morning reminder',
  save: 'Save',
  saved: 'Saved.',
  preview: (text) => `Notification: ${text}`,
  eveningText: "This evening's new words are waiting.",
  morningText: "Last night's new words: a short recall first.",
};

// Messages.reminderPlan (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('reminderPlan', reminderPlanFi, reminderPlanEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof reminderPlanFi> {}
}
